export default __webpack_public_path__ + "static/media/json.9c37ee6e.svg";